/* global Site */

export function init() {
	let element = document.querySelector('.js-instagram-feed');

	if (!element) {
		return;
	}

	let selector = '.js-instagram-image';
	let placeholders = Array.from(element.querySelectorAll(selector));

	let observer = new IntersectionObserver(onIntersection, {
		rootMargin: '20%',
	});

	observer.observe(element);

	function onIntersection(entries) {
		let entry = entries[0];

		if (!entry.isIntersecting) {
			return;
		}

		getMedia(placeholders.length).then(json => {
			json.media.forEach((media, i) => {
				let img = document.createElement('img');
				img.src = media.mediaUrl;

				placeholders[i].appendChild(img);
			});
		});

		observer.unobserve(element);
	}

	function getMedia(limit) {
		let url = `${Site.baseUrl}actions/instagram/media/fetch?limit=${limit}`;

		return fetch(url).then(response => response.json());
	}
}
